import { Component, OnInit, EventEmitter, Output, Input, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

import { Collana } from '../../../models/Collana';

@Component({
  selector: 'app-collana-filter',
  templateUrl: './collana-filter.component.html',
  styleUrls: ['./collana-filter.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CollanaFilterComponent),
      multi: true
    }
  ]
})
export class CollanaFilterComponent implements OnInit {
  collana: Collana;
  @Output() confirmNotify: EventEmitter<any> = new EventEmitter<any>();
  @Output() quitNotify: EventEmitter<any> = new EventEmitter<any>();

  constructor() { }

  confirm() {
    this.confirmNotify.emit({ q: { field: 'collana.code', value: this.collana.codice }, t: { k: 'COLLANA', v: this.collana.codice, l: 'collana' }, o: this.collana });
  }

  enter(e) {
    if(e) e.preventDefault();

    if (this.collana) {
      this.confirm()
    }
  }

  quit() {
    this.quitNotify.emit();
  }

  ngOnInit() { }

  private propagateChange = (_: any) => { };

  public writeValue(collana: Collana) {
    this.collana = collana;
  }

  public registerOnChange(fn: any) {
    this.propagateChange = fn;
  }

  public registerOnTouched() { }
}



// WEBPACK FOOTER //
// ./src/app/helpers/filters/collana-filter/collana-filter.component.ts